import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

const useDetectRateMode = () => {
  const rateUpdatesMode = getUrlParam('mode') === 'rate-updates';
  return { rateUpdatesMode };
};

export default useDetectRateMode;
